<template>
  <div>
    <b-tooltip :target="target" :triggers="triggers" :placement="placement">{{ label }}</b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    target: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'top'
    },
    triggers: {
      type: String,
      default: 'hover'
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>
